import React, {useContext, useRef, useState} from "react";
import {Link} from "react-router-dom";
import './NavBar.css';
import {AuthContext} from "../../providers/AuthProvider";
import {useLastAppVersion, useLastMessage, useOutsideAlerter} from "../../api/hooks";
import {CommonHelper} from "../CommonHelper";

export const NavBar = () => {
    const {logout, user, isAdmin, hasSeenMessage, setSeenMessage} = useContext(AuthContext);
    const navRef = useRef<HTMLDivElement>(null);
    const userButtonRef = useRef<HTMLDivElement>(null);
    const [refresh, setRefresh] = useState(0);
    const {data: latestAppVersion} = useLastAppVersion();
    const {data: latestMessage} = useLastMessage();

    useOutsideAlerter(userButtonRef, () => {
        if (userButtonRef.current.classList.contains('show')) {
            setImmediate(() => {
                userButtonRef.current.classList.remove('show');
            })
        }
    });

    return (
        <header id="header">
            <nav className="navbar navbar-light navbar-expand-md">
                <div className="container-fluid">
                    <img className="navbar-brand" src={process.env.PUBLIC_URL + '/img/logo.svg'}
                         alt="Bouygues Immobilier logo"/>


                    <div className="link-brand link-brand-center">
                        <Link to={`${process.env.PUBLIC_URL}/`} className="link-brand">
                            <img className="navbar-brand" src={process.env.PUBLIC_URL + '/img/rezerve_logo.png'}
                                 alt="Bouygues Immobilier logo"/>
                            <h4 className="mb-0">eZerv</h4>
                        </Link>
                    </div>

                    {user && <>
                        <button className="navbar-toggler" type="button" data-toggle="collapse"
                                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                aria-expanded="false"
                                onClick={() => {
                                    if (navRef.current.classList.contains('show')) {
                                        navRef.current.classList.remove('show');
                                    } else {
                                        navRef.current.classList.add('show');
                                    }
                                }}
                                aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse" ref={navRef}>
                            <ul className="navbar-nav ml-auto">

                                {latestAppVersion !== undefined &&
                                    <li className="nav-item">
                                        <a
                                            className="nav-link btn btn-sm btn-primary btn-download-app"
                                            href={latestAppVersion.downloadUrl}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Application{' '}
                                            <i className="fa fa-cloud-download-alt"></i>
                                        </a>
                                    </li>}

                                {isAdmin() &&
                                    <li className="nav-item">
                                        <Link className="nav-link" to={`${process.env.PUBLIC_URL}/user`}>
                                            <i className="fa fa-users"/>
                                        </Link>
                                    </li>}
                                {isAdmin() &&
                                    <li className="nav-item">
                                        <Link className="nav-link" to={`${process.env.PUBLIC_URL}/app-version?o=1`}>
                                            <i className="fa fa-tablet-alt"/>
                                        </Link>
                                    </li>}
                                {isAdmin() &&
                                    <li className="nav-item mr-2">
                                        <Link className="nav-link" to={`${process.env.PUBLIC_URL}/message?o=1`}>
                                            <i className="fa fa-comments"/>
                                        </Link>
                                    </li>}

                                <li className="nav-item dropdown">
                                    <button className="nav-link dropdown-toggle" type="button"
                                            onClick={() => {
                                                if (userButtonRef.current.classList.contains('show')) {
                                                    userButtonRef.current.classList.remove('show');
                                                } else {
                                                    userButtonRef.current.classList.add('show');
                                                }
                                            }}
                                    >
                                        {user.prenom} {user.nom}
                                    </button>

                                    <div className="dropdown-menu" ref={userButtonRef}>
                                        <Link className="nav-link" to={`${process.env.PUBLIC_URL}/user/me`}>
                                            <i className="fa fa-user"/> Profil
                                        </Link>
                                        <div className="dropdown-divider"></div>
                                        <Link className="nav-link" to='/login' onClick={() => {
                                            logout();
                                        }}>
                                            <i className="fa fa-sign-out-alt"/> Déconnexion
                                        </Link>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </>}
                </div>
            </nav>
            {latestMessage && !hasSeenMessage(latestMessage.refMessage) && (
                <nav className="navbar navbar-light navbar-expand-md background-light-green">
                    <div className="container-fluid">
                        <div>
                            <p className="mb-0 font-weight-bolder">{latestMessage.message}</p>
                            <p className="mb-0"><small>{CommonHelper.formatDate(latestMessage.dateCreation)}</small></p>
                        </div>
                        <div>
                            <button className="btn btn-secondary flex-grow-1" type="button" onClick={() => {
                                setSeenMessage(latestMessage.refMessage);
                                setRefresh(refresh + 1);
                            }}>
                                Compris{' '}
                                <i className="fa fa-check"/>
                            </button>
                        </div>
                    </div>
                </nav>
            )}
        </header>
    );

};
